import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { HomePage } from '@/pages/Home';
import { LoginModal } from '@/components/LoginModal';

export const Route = createFileRoute('/')({
  component: HomeWithLogin,
});

function HomeWithLogin() {
  // Read search params without strict validation
  const searchParams = new URLSearchParams(window.location.search);
  const showLogin = searchParams.get('showLogin') === 'true';
  const navigate = useNavigate();

  const handleCloseLogin = () => {
    navigate({ to: '/' });
  };

  return (
    <>
      <HomePage />
      {showLogin && <LoginModal onClose={handleCloseLogin} />}
    </>
  );
}
